export default __webpack_public_path__ + "static/media/medicine.a2570ec9.png";